import { render, staticRenderFns } from "./BookingPresetForm.vue?vue&type=template&id=1c490020&scoped=true&"
import script from "./BookingPresetForm.vue?vue&type=script&lang=js&"
export * from "./BookingPresetForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingPresetForm.vue?vue&type=style&index=0&id=1c490020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c490020",
  null
  
)

export default component.exports